import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/page/Auth'

import Test from '@/page/test/index'
import Hospital from '@/page/hospital/index'
import My from '@/page/hospital/My';
import ShortUrl from '@/page/shorturl/index'
import Zone from '@/page/zone/index'
import Showcase from '@/page/showcase/Showcase'
import ShowcaseHome from '@/page/showcase/Home'
import ShowcaseSignUp from '@/page/showcase/SignUp'
import ShowcasePreview from '@/page/showcase/Preview'

import Sleepq from '@/page/sleepq/index'
import Anzeilax from '@/page/anzeilax/index'
import Bluekare from '@/page/bluekare/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/sleepq',
      name: 'sleepq',
      component: Sleepq,
      meta: { title: '슬립큐전용'}
    },
    {
      path: '/anzeilax',
      name: 'anzeilax',
      component: Anzeilax,
      meta: { title: '엥자이렉스전용' }
    },
    {
      path: '/bluekare',
      name: 'bluekare',
      component: Bluekare,
      meta: { title: '블루케어전용' }
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      meta: { title: '테스트환경' }
    },
    {
      path: '/auth/callback',
      name: 'auth',
      component: Auth
    },
    {
      path: '/hospital/:uuid',
      name: 'hospital',
      component: Hospital,
      meta: { title: '솔닥' }
    },
      {
      path: '/my/hospital',
      name: 'my',
      component: My,
      meta: { title: '솔닥' }
    },
    {
      path: '/shorturl',
      name: 'shorturl',
      component: ShortUrl
    },
    {
      path: '/zone',
      name: 'zone',
      component: Zone
    },
    {
      path: '/:showcase(xi|kocom)',
      component: Showcase,
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          name: 'showcase-home',
          component: ShowcaseHome
        },
        {
          path: 'signup',
          name: 'showcase-signup',
          component: ShowcaseSignUp
        },
        {
          path: 'preview',
          name: 'showcase-preview',
          component: ShowcasePreview
        }
      ],
      meta: { title: '모델하우스' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js